import type { AssetTypeTemplateDeleteButtonProps } from "./asset-type-template-delete-button.type";

import { useTranslation } from "react-i18next";

export const useAssetTypeTemplateDeleteButton = ({
  entityTemplate,
}: AssetTypeTemplateDeleteButtonProps) => {
  const { t } = useTranslation();

  const isDeletable = entityTemplate.is_deletable;
  const tooltip = !isDeletable ? t("technicalForm:delete.disabled") : undefined;

  return {
    isDeletable,
    tooltip,
  };
};
